import { useTranslation } from 'i18n';
import { Button } from 'components/ui';

import styles from './Error.module.scss';

type Props = {
  buttonLabel: string;
  onClose: () => void;
};

const Error = ({ buttonLabel, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.error}>
      <Button style={{ root: { height: '2.2rem', width: '100%' } }} onClick={onClose}>
        {t(buttonLabel)}
      </Button>
    </div>
  );
};

export default Error;
